// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   ToursXplorer Supplier — Public Landing Page
   Self-contained styles (prefix: lp-)
   Theme: #F5A524 (amber) / #161C27 (dark)
   ============================================================ */

.lp-page {
    --lp-amber: #E3BD3E;
    --lp-amber-dark: #c9a52f;
    --lp-dark: #161C27;
    --lp-text: #3f4654;
    --lp-muted: #6b7280;
    --lp-cream: #FFF9F0;
    --lp-cream-2: #FDF3E4;
    --lp-hero-bg: #FEFEFE;
    --lp-border: #efe6d6;
    --lp-white: #ffffff;
    font-family: 'Manrope-Regular', 'Segoe UI', system-ui, -apple-system, sans-serif;
    color: var(--lp-text);
    background: var(--lp-hero-bg);
    overflow-x: hidden;
}

.lp-page * {
    box-sizing: border-box;
}

/* Match the supplier app — Manrope family (@font-face defined globally in /assest/css/style.css).
   Each weight is its own font file, so use the named family rather than font-weight. */
.lp-page h1,
.lp-page h2,
.lp-page h3,
.lp-page h4,
.lp-page h5,
.lp-page h6,
.lp-stat-num,
.lp-fc-num {
    font-family: 'Manrope-Bold';
}

.lp-btn,
.lp-nav a,
.lp-eyebrow,
.lp-badge,
.lp-hero-checks span,
.lp-tag-choice,
.lp-brands-box .lp-brand,
.lp-testimonial-author span {
    font-family: 'Manrope-SemiBold';
}

.lp-container {
    width: 100%;
    max-width: 1320px;
    margin: 0 auto;
    padding: 0 20px;
}

.lp-page img:not(.lp-hero-image) {
    max-width: 100%;
}

/* Offset anchored sections so the sticky header doesn't cover their headings */
.lp-page section[id],
.lp-page #lp-home {
    scroll-margin-top: 90px;
}

/* ---------- Buttons ---------- */
.lp-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    font-size: 15px;
    font-weight: 600;
    line-height: 1;
    padding: 13px 24px;
    border-radius: 10px;
    border: 1.5px solid transparent;
    cursor: pointer;
    text-decoration: none;
    transition: all .2s ease;
    white-space: nowrap;
}

.lp-btn-primary {
    background: var(--lp-amber);
    color: #1c1208;
    box-shadow: none;
}

.lp-btn-primary:hover {
    background: var(--lp-amber-dark);
    color: #1c1208;
}

.lp-btn-outline {
    background: transparent;
    color: var(--lp-dark);
    border-color: #e2e2e2;
}

.lp-btn-outline:hover {
    border-color: var(--lp-amber);
    color: var(--lp-amber-dark);
}

.lp-btn-lg {
    padding: 15px 28px;
    font-size: 16px;
}

/* ---------- Header ---------- */
.lp-header {
    position: sticky;
    top: 0;
    z-index: 50;
    padding: 10px 0;
    background: var(--lp-hero-bg);
    border-bottom: 1px solid #0000001a;
}

.lp-header-inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 68px;
    gap: 24px;
}

.lp-logo {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    text-decoration: none;
}

.lp-logo-wrap {
    position: relative;
    display: inline-block;
}

.lp-logo-img {
    width: 152px;
    height: auto;
    display: block;
}

.lp-logo-tag {
    position: absolute;
    top: -9px;
    right: -20px;
}

.lp-logo-tag img {
    width: 56px;
    display: block;
}

.lp-nav {
    display: flex;
    align-items: center;
    gap: 22px;
    margin: 0 auto;
}

.lp-nav a {
    font-size: 15px;
    font-weight: 500;
    color: #4a5160;
    text-decoration: none;
    position: relative;
    white-space: nowrap;
    transition: color .2s;
}

.lp-nav a:hover,
.lp-nav a.active {
    color: var(--lp-amber-dark);
}

.lp-nav a.active::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: -30px;
    width: 100%;
    height: 2px;
    background: var(--lp-amber);
}

.lp-header-actions {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-shrink: 0;
}

.lp-burger {
    display: none;
    background: none;
    border: none;
    font-size: 22px;
    color: var(--lp-dark);
    cursor: pointer;
}

/* ---------- Section base ---------- */
.lp-section {
    padding: 80px 0;
}

.lp-eyebrow {
    display: inline-block;
    color: var(--lp-amber-dark);
    font-weight: 600;
    font-size: 14px;
    letter-spacing: .3px;
    margin-bottom: 10px;
}

.lp-section-title {
    font-size: 34px;
    font-weight: 700;
    color: var(--lp-dark);
    margin: 0 0 14px;
    line-height: 1.25;
}

.lp-section-head {
    text-align: center;
    max-width: 640px;
    margin: 0 auto 50px;
}

.lp-section-head .lp-section-title {
    margin-bottom: 0;
}

.lp-amber-text {
    color: var(--lp-amber);
}

/* ---------- Hero ---------- */
.lp-hero {
    background: transparent;
    padding: 34px 0 64px;
}

.lp-hero-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
    align-items: center;
}

.lp-badge {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: #FDEFD3;
    color: #9a6a05;
    font-size: 13px;
    font-weight: 600;
    padding: 7px 14px;
    border-radius: 30px;
    margin-bottom: 22px;
}

.lp-hero h1 {
    font-size: 40px;
    line-height: 1.18;
    font-weight: 700;
    color: var(--lp-dark);
    margin: 0 0 18px;
}

.lp-hero h1 .lp-h1-line {
    display: block;
    white-space: nowrap;
}

.lp-hero-sub {
    font-size: 16px;
    color: var(--lp-muted);
    max-width: 460px;
    margin: 0 0 26px;
    line-height: 1.6;
}

.lp-hero-features {
    display: flex;
    flex-direction: column;
    gap: 18px;
    margin-bottom: 30px;
}

.lp-feature {
    display: flex;
    gap: 14px;
    align-items: flex-start;
}

.lp-feature-ico {
    width: 44px;
    height: 44px;
    flex-shrink: 0;
    border-radius: 12px;
    background: #FDEFD3;
    color: var(--lp-amber-dark);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
}

.lp-feature h4 {
    margin: 0 0 3px;
    font-size: 16px;
    font-weight: 600;
    color: var(--lp-dark);
}

.lp-feature p {
    margin: 0;
    width: 80%;
    font-size: 14px;
    color: var(--lp-muted);
    line-height: 1.5;
}

.lp-hero-btns {
    display: flex;
    gap: 14px;
    flex-wrap: wrap;
    margin-bottom: 22px;
}

.lp-hero-checks {
    display: flex;
    gap: 22px;
    flex-wrap: wrap;
}

.lp-hero-checks span {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    font-size: 13.5px;
    color: #56607a;
}

.lp-hero-checks i {
    color: var(--lp-amber);
}

/* Hero visual */
.lp-hero-visual {
    position: relative;
}

.lp-hero-image {
    width: 112%;
    max-width: 112%;
    height: auto;
    display: block;
    margin-left: 0;
}

.lp-float-card {
    position: absolute;
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 18px 45px rgba(22, 28, 39, .16);
    padding: 16px 18px;
}

.lp-float-suppliers {
    bottom: 18px;
    right: 0;
    min-width: 200px;
    z-index: 5;
}

.lp-avatars {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
}

.lp-avatars img {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    object-fit: cover;
    border: 2px solid #fff;
    margin-left: -10px;
}

.lp-avatars img:first-child {
    margin-left: 0;
}

.lp-avatars .lp-av-more {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    background: var(--lp-amber);
    color: #1c1208;
    font-size: 11px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid #fff;
    margin-left: -10px;
}

.lp-float-suppliers h6 {
    margin: 0;
    font-size: 14px;
    font-weight: 700;
    color: var(--lp-dark);
}

.lp-stars {
    color: var(--lp-amber);
    font-size: 12px;
    margin-top: 4px;
}

/* ---------- Brands strip (white pill, real brand logos) ---------- */
.lp-brands {
    padding: 24px 0 14px;
}

.lp-brands-label {
    text-align: center;
    font-size: 13px;
    color: var(--lp-muted);
    margin-bottom: 16px;
}

.lp-brands-box {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 20px 38px;
    width: fit-content;
    max-width: calc(100% - 40px);
    margin: 0 auto;
    background: #fff;
    border: 1px solid #eef0f2;
    border-radius: 16px;
    padding: 22px 44px;
    box-shadow: 0 12px 30px rgba(22, 28, 39, .06);
}

.lp-logo-item {
    display: inline-flex;
    align-items: center;
    line-height: 1;
    height: 34px;
}

/* Bókun — real dark logo */
.lp-logo-bokun img {
    height: 30px;
    width: auto;
    display: block;
}

/* FareHarbor — real vector */
.lp-logo-fh svg {
    height: 26px;
    width: auto;
    fill: #0a6ece;
}

/* Pluralo — icon + dark wordmark (project asset is white for dark bg) */
.lp-logo-pluralo {
    font-family: 'Manrope-ExtraBold';
    font-size: 22px;
    color: #1b1b29;
    gap: 8px;
}

.lp-logo-pluralo svg {
    width: 24px;
    height: 24px;
}

/* rezdy — real vector */
.lp-logo-rezdy svg {
    height: 26px;
    width: auto;
}

/* octo — real vector */
.lp-logo-octo svg {
    height: 26px;
    width: auto;
}

/* turitop — real logo */
.lp-logo-turitop img {
    height: 30px;
    width: auto;
    display: block;
}

.lp-brands-more {
    font-size: 14px;
    color: var(--lp-muted);
}

/* ---------- Visibility section ---------- */
.lp-visibility {
    background: linear-gradient(180deg, #FFFCF5 0%, #FFF5E6 100%);
    padding-top: 18px;
    padding-bottom: 64px;
}

.lp-vis-grid {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 28px;
    align-items: center;
}

/* scroll-reveal so the section draws focus as the visitor reaches it */
.lp-visibility .lp-vis-grid > * {
    opacity: 0;
    transform: translateY(42px) scale(.97);
    transition: opacity .7s ease, transform .7s cubic-bezier(.22, 1, .36, 1);
}

.lp-visibility.lp-revealed .lp-vis-grid > * {
    opacity: 1;
    transform: none;
}

.lp-visibility.lp-revealed .lp-vis-grid > *:nth-child(2) {
    transition-delay: .16s;
}

.lp-visibility.lp-revealed .lp-vis-grid > *:nth-child(3) {
    transition-delay: .32s;
}

/* always-on attention cue on the badge */
@keyframes lp-badge-pulse {
    0% {
        box-shadow: 0 0 0 0 rgba(227, 189, 62, .55);
    }
    70% {
        box-shadow: 0 0 0 12px rgba(227, 189, 62, 0);
    }
    100% {
        box-shadow: 0 0 0 0 rgba(227, 189, 62, 0);
    }
}

@media (prefers-reduced-motion: reduce) {
    .lp-visibility .lp-vis-grid > * {
        opacity: 1;
        transform: none;
        transition: none;
    }

    .lp-vis-mid .lp-eyebrow {
        animation: none;
    }
}

.lp-vis-mock {
    background: #FDF3E2;
    border-radius: 18px;
    padding: 22px;
    box-shadow: inset 0 0 0 1px #f4e6cb;
}

.lp-vis-search {
    display: flex;
    align-items: center;
    gap: 10px;
    background: #fff;
    border-radius: 10px;
    padding: 11px 14px;
    font-size: 13px;
    color: #9aa1ad;
    box-shadow: 0 4px 14px rgba(0, 0, 0, .05);
    margin-bottom: 16px;
}

.lp-vis-search i {
    margin-left: auto;
    color: var(--lp-amber);
}

.lp-vis-prod {
    display: flex;
    gap: 12px;
    align-items: center;
    background: #fff;
    border-radius: 12px;
    padding: 12px;
    box-shadow: 0 8px 22px rgba(0, 0, 0, .07);
    margin-bottom: 14px;
}

.lp-vis-prod img {
    width: 64px;
    height: 56px;
    object-fit: cover;
    border-radius: 8px;
}

.lp-vis-prod h6 {
    margin: 0 0 4px;
    font-size: 14px;
    font-weight: 600;
    color: var(--lp-dark);
}

.lp-vis-prod .lp-vis-meta {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 12px;
    color: var(--lp-muted);
}

.lp-vis-prod .lp-vis-price {
    font-weight: 700;
    color: var(--lp-dark);
}

.lp-tag-choice {
    background: #FDEFD3;
    color: #9a6a05;
    font-size: 10px;
    font-weight: 700;
    padding: 3px 8px;
    border-radius: 20px;
}

.lp-vis-ghost {
    height: 12px;
    border-radius: 6px;
    background: #f1e4ca;
    margin-bottom: 10px;
}

.lp-vis-ghost.s {
    width: 60%;
}

.lp-vis-mid .lp-eyebrow {
    background: var(--lp-amber);
    color: #5b4406;
    padding: 7px 14px;
    border-radius: 20px;
    animation: lp-badge-pulse 2.2s ease-out infinite;
}

.lp-vis-mid h3 {
    font-size: 30px;
    font-weight: 700;
    color: var(--lp-dark);
    margin: 16px 0 14px;
    line-height: 1.28;
}

.lp-vis-mid p {
    font-size: 14.5px;
    color: var(--lp-muted);
    line-height: 1.6;
    margin: 0;
}

.lp-vis-list {
    display: flex;
    flex-direction: column;
    gap: 22px;
}

.lp-vis-item {
    display: flex;
    gap: 13px;
}

.lp-vis-item > i {
    width: 38px;
    height: 38px;
    flex-shrink: 0;
    border-radius: 10px;
    background: #FDEFD3;
    color: var(--lp-amber-dark);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
}

.lp-vis-item h5 {
    margin: 0 0 3px;
    font-size: 15px;
    font-weight: 600;
    color: var(--lp-dark);
}

.lp-vis-item p {
    margin: 0;
    font-size: 13px;
    color: var(--lp-muted);
    line-height: 1.5;
}

/* ---------- Steps ---------- */
.lp-steps {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    gap: 0;
    flex-wrap: wrap;
}

.lp-step {
    flex: 1 1;
    min-width: 200px;
    text-align: center;
    padding: 0 18px;
}

.lp-step-ico {
    width: 70px;
    height: 70px;
    margin: 0 auto 18px;
    border-radius: 50%;
    background: #FDEFD3;
    color: var(--lp-amber-dark);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
}

.lp-step h4 {
    margin: 0 0 8px;
    font-size: 17px;
    font-weight: 600;
    color: var(--lp-dark);
}

.lp-step p {
    margin: 0;
    font-size: 14px;
    color: var(--lp-muted);
    line-height: 1.55;
}

.lp-step-arrow {
    align-self: center;
    color: var(--lp-amber);
    font-size: 22px;
    padding-top: 20px;
    letter-spacing: 2px;
}

/* ---------- Benefits cards ---------- */
.lp-benefits {
    background: #FFFBF3;
}

.lp-bene-grid {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 18px;
}

.lp-bene-card {
    background: #fff;
    border: 1px solid var(--lp-border);
    border-radius: 16px;
    padding: 26px 18px;
    text-align: center;
    transition: all .25s ease;
}

.lp-bene-card:hover {
    transform: translateY(-6px);
    box-shadow: 0 18px 36px rgba(22, 28, 39, .1);
    border-color: var(--lp-amber);
}

.lp-bene-ico {
    width: 56px;
    height: 56px;
    margin: 0 auto 16px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 21px;
}

.lp-bene-card h4 {
    margin: 0 0 8px;
    font-size: 15px;
    font-weight: 600;
    color: var(--lp-dark);
}

.lp-bene-card p {
    margin: 0;
    font-size: 12.5px;
    color: var(--lp-muted);
    line-height: 1.55;
}

/* ---------- Trusted / stats ---------- */
.lp-trusted-grid {
    display: grid;
    grid-template-columns: 1.1fr .9fr;
    gap: 50px;
    align-items: center;
}

.lp-trusted-left {
    text-align: center;
}

.lp-trusted h2 {
    font-size: 30px;
    font-weight: 700;
    color: var(--lp-dark);
    margin: 6px 0 30px;
    line-height: 1.3;
}

.lp-stats {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 18px;
}

.lp-stat {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 4px;
}

.lp-stat i {
    font-size: 28px;
    color: var(--lp-amber);
    margin-bottom: 8px;
}

.lp-stat .lp-stat-num {
    font-size: 24px;
    font-weight: 700;
    color: var(--lp-dark);
    line-height: 1;
}

.lp-stat .lp-stat-label {
    font-size: 12.5px;
    color: var(--lp-muted);
    margin-top: 5px;
}

.lp-testimonial {
    background: #FDF3E2;
    border: 1px solid #f3e6cd;
    border-radius: 18px;
    padding: 32px;
    position: relative;
    /* stable height so swapping testimonials of different lengths doesn't shift layout */
    min-height: 290px;
    display: flex;
    flex-direction: column;
}

.lp-testimonial p {
    flex: 1 1;
}

.lp-testimonial .lp-quote-mark {
    font-size: 50px;
    line-height: 1;
    color: var(--lp-amber);
    font-family: Georgia, serif;
    opacity: .5;
}

.lp-testimonial p {
    font-size: 15.5px;
    color: var(--lp-text);
    line-height: 1.6;
    margin: 4px 0 22px;
}

.lp-testimonial-author {
    display: flex;
    align-items: center;
    gap: 12px;
}

.lp-testimonial-author img {
    width: 46px;
    height: 46px;
    border-radius: 50%;
    object-fit: cover;
}

.lp-testimonial-author h6 {
    margin: 0;
    font-size: 15px;
    font-weight: 700;
    color: var(--lp-dark);
}

.lp-testimonial-author span {
    font-size: 12.5px;
    color: var(--lp-amber-dark);
}

/* testimonial slider nav */
.lp-testimonial-nav {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 18px;
    margin-top: 20px;
}

.lp-tnav-btn {
    width: 38px;
    height: 38px;
    border-radius: 50%;
    border: 1px solid var(--lp-border);
    background: #fff;
    color: var(--lp-dark);
    font-size: 13px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all .2s;
}

.lp-tnav-btn:hover {
    background: var(--lp-amber);
    border-color: var(--lp-amber);
    color: #1c1208;
}

.lp-tnav-dots {
    display: flex;
    align-items: center;
    gap: 8px;
}

.lp-tnav-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    border: none;
    padding: 0;
    background: #e2d9c4;
    cursor: pointer;
    transition: all .2s;
}

.lp-tnav-dot.active {
    width: 22px;
    border-radius: 5px;
    background: var(--lp-amber);
}

/* ---------- CTA banner ---------- */
.lp-cta {
    padding: 30px 0 90px;
}

.lp-cta-box {
    background: linear-gradient(120deg, #FDF3E2 0%, #FCEBCB 100%);
    border-radius: 22px;
    padding: 46px 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 30px;
    flex-wrap: wrap;
    overflow: hidden;
    position: relative;
}

.lp-cta-text {
    display: flex;
    align-items: center;
    gap: 24px;
}

.lp-cta-img {
    width: 96px;
    height: auto;
    flex-shrink: 0;
}

.lp-cta-text h3 {
    margin: 0 0 6px;
    font-size: 26px;
    font-weight: 700;
    color: var(--lp-dark);
}

.lp-cta-text p {
    margin: 0;
    font-size: 14.5px;
    color: var(--lp-muted);
}

.lp-cta-btns {
    display: flex;
    gap: 14px;
    flex-wrap: wrap;
}

/* ---------- Footer ---------- */
.lp-footer {
    background: var(--lp-dark);
    color: #aeb4c0;
    padding: 60px 0 26px;
}

.lp-footer-grid {
    display: grid;
    grid-template-columns: 2fr 1fr 1fr 1.2fr 1.6fr;
    gap: 32px;
    padding-bottom: 40px;
    border-bottom: 1px solid rgba(255, 255, 255, .08);
}

.lp-footer-brand img {
    height: 28px;
    margin-bottom: 16px;
}

.lp-footer-brand p {
    font-size: 13.5px;
    line-height: 1.6;
    margin: 0 0 18px;
    max-width: 280px;
}

.lp-footer-social {
    display: flex;
    gap: 12px;
}

.lp-footer-social a {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: rgba(255, 255, 255, .08);
    color: #cfd4dd;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    transition: all .2s;
}

.lp-footer-social a:hover {
    background: var(--lp-amber);
    color: #1c1208;
}

.lp-footer-col h5 {
    color: #fff;
    font-size: 15px;
    font-weight: 600;
    margin: 0 0 18px;
}

.lp-footer-col ul {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 11px;
}

.lp-footer-col ul a {
    color: #aeb4c0;
    font-size: 13.5px;
    text-decoration: none;
    transition: color .2s;
}

.lp-footer-col ul a:hover {
    color: var(--lp-amber);
}

.lp-footer-news p {
    font-size: 13.5px;
    line-height: 1.6;
    margin: 0 0 16px;
}

.lp-news-form {
    display: flex;
    background: rgba(255, 255, 255, .08);
    border-radius: 10px;
    padding: 5px;
}

.lp-news-form input {
    flex: 1 1;
    background: transparent;
    border: none;
    outline: none;
    color: #fff;
    font-size: 13.5px;
    padding: 9px 12px;
}

.lp-news-form input::placeholder {
    color: #8b91a0;
}

.lp-news-form button {
    background: var(--lp-amber);
    color: #1c1208;
    border: none;
    width: 40px;
    border-radius: 8px;
    cursor: pointer;
    font-size: 15px;
    flex-shrink: 0;
}

.lp-footer-bottom {
    text-align: center;
    padding-top: 24px;
    font-size: 13px;
    color: #8b91a0;
}

/* ---------- Mobile menu ---------- */
.lp-mobile-nav {
    display: none;
}

/* ---------- Responsive ---------- */
@media (max-width: 1024px) {
    .lp-nav {
        gap: 18px;
    }

    .lp-nav a {
        font-size: 13.5px;
    }

    .lp-bene-grid {
        grid-template-columns: repeat(3, 1fr);
    }

    .lp-vis-grid {
        grid-template-columns: 1fr;
    }

    .lp-trusted-grid {
        grid-template-columns: 1fr;
    }
}

@media (max-width: 860px) {
    .lp-hero-grid {
        grid-template-columns: 1fr;
    }

    .lp-hero h1 {
        font-size: 34px;
    }

    .lp-hero h1 .lp-h1-line {
        white-space: normal;
    }

    .lp-hero-image {
        width: 100%;
        max-width: 100%;
        margin: 0;
    }

    .lp-hero-visual {
        margin-top: 30px;
    }

    .lp-section {
        padding: 56px 0;
    }

    .lp-section-title,
    .lp-trusted h2 {
        font-size: 26px;
    }

    .lp-steps {
        flex-direction: column;
        align-items: stretch;
        gap: 30px;
    }

    .lp-step-arrow {
        display: none;
    }

    .lp-stats {
        grid-template-columns: repeat(2, 1fr);
        gap: 28px;
    }

    .lp-cta-box {
        flex-direction: column;
        align-items: flex-start;
        text-align: left;
        padding: 34px 26px;
    }

    .lp-footer-grid {
        grid-template-columns: 1fr 1fr;
        gap: 28px;
    }

    /* Mobile slide-in nav */
    .lp-mobile-nav {
        display: block;
        position: fixed;
        top: 0;
        right: 0;
        height: 100vh;
        width: 78%;
        max-width: 320px;
        background: #fff;
        box-shadow: -10px 0 40px rgba(0, 0, 0, .15);
        z-index: 100;
        transform: translateX(100%);
        transition: transform .3s ease;
        padding: 24px;
    }

    .lp-mobile-nav.open {
        transform: translateX(0);
    }

    .lp-mobile-nav .lp-mobile-close {
        background: none;
        border: none;
        font-size: 24px;
        color: var(--lp-dark);
        margin-bottom: 20px;
        cursor: pointer;
    }

    .lp-mobile-nav ul {
        list-style: none;
        margin: 0 0 24px;
        padding: 0;
        display: flex;
        flex-direction: column;
        gap: 4px;
    }

    .lp-mobile-nav ul a {
        display: block;
        padding: 12px 8px;
        font-size: 15px;
        font-weight: 500;
        color: var(--lp-dark);
        text-decoration: none;
        border-bottom: 1px solid #f3f3f3;
    }

    .lp-mobile-nav .lp-btn {
        width: 100%;
        margin-bottom: 10px;
    }

    .lp-mobile-overlay {
        position: fixed;
        inset: 0;
        background: rgba(0, 0, 0, .4);
        z-index: 99;
    }
}

@media (max-width: 560px) {
    .lp-bene-grid {
        grid-template-columns: 1fr 1fr;
    }

    .lp-header-inner {
        height: 70px;
        gap: 10px;
    }

    .lp-logo-img {
        width: 132px;
    }

    .lp-logo-tag img {
        width: 50px;
    }

    .lp-header-actions {
        gap: 8px;
    }

    .lp-header-actions .lp-btn {
        padding: 9px 13px;
        font-size: 13px;
    }

    .lp-hero h1 {
        font-size: 30px;
    }

    .lp-float-suppliers {
        right: 0;
        bottom: 12px;
        min-width: 170px;
    }

    .lp-footer-grid {
        grid-template-columns: 1fr;
    }

    .lp-cta-text {
        flex-direction: column;
        align-items: flex-start;
    }
}
`, "",{"version":3,"sources":["webpack://./src/assest/css/landing.css"],"names":[],"mappings":"AAAA;;;;iEAIiE;;AAEjE;IACI,mBAAmB;IACnB,wBAAwB;IACxB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,qBAAqB;IACrB,qBAAqB;IACrB,oBAAoB;IACpB,mBAAmB;IACnB,gFAAgF;IAChF,qBAAqB;IACrB,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;uFACuF;AACvF;;;;;;;;IAQI,2BAA2B;AAC/B;;AAEA;;;;;;;;IAQI,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA,+EAA+E;AAC/E;;IAEI,uBAAuB;AAC3B;;AAEA,kCAAkC;AAClC;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,+BAA+B;IAC/B,eAAe;IACf,qBAAqB;IACrB,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,6BAA6B;IAC7B,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA,iCAAiC;AACjC;IACI,gBAAgB;IAChB,MAAM;IACN,WAAW;IACX,eAAe;IACf,6BAA6B;IAC7B,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,aAAa;IACb,WAAW;IACX,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,qBAAqB;IACrB,eAAe;AACnB;;AAEA,uCAAuC;AACvC;IACI,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,2BAA2B;IAC3B,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,+BAA+B;AAC/B;IACI,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,eAAe;IACf,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,gBAAgB;AAChB;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,6CAA6C;IAC7C,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,QAAQ;IACR,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,2BAA2B;IAC3B,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,eAAe;AACnB;;AAEA,sEAAsE;AACtE;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,4BAA4B;IAC5B,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,6CAA6C;AACjD;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;IACd,YAAY;AAChB;;AAEA,2BAA2B;AAC3B;IACI,YAAY;IACZ,WAAW;IACX,cAAc;AAClB;;AAEA,6BAA6B;AAC7B;IACI,YAAY;IACZ,WAAW;IACX,aAAa;AACjB;;AAEA,wEAAwE;AACxE;IACI,gCAAgC;IAChC,eAAe;IACf,cAAc;IACd,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA,wBAAwB;AACxB;IACI,YAAY;IACZ,WAAW;AACf;;AAEA,uBAAuB;AACvB;IACI,YAAY;IACZ,WAAW;AACf;;AAEA,wBAAwB;AACxB;IACI,YAAY;IACZ,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,sBAAsB;AAC1B;;AAEA,6CAA6C;AAC7C;IACI,6DAA6D;IAC7D,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,kCAAkC;IAClC,SAAS;IACT,mBAAmB;AACvB;;AAEA,uEAAuE;AACvE;IACI,UAAU;IACV,sCAAsC;IACtC,wEAAwE;AAC5E;;AAEA;IACI,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,yCAAyC;AACzC;IACI;QACI,2CAA2C;IAC/C;IACA;QACI,4CAA4C;IAChD;IACA;QACI,yCAAyC;IAC7C;AACJ;;AAEA;IACI;QACI,UAAU;QACV,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,yCAAyC;IACzC,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,yCAAyC;IACzC,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,2BAA2B;IAC3B,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,gDAAgD;AACpD;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA,gCAAgC;AAChC;IACI,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,MAAM;IACN,eAAe;AACnB;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA,yCAAyC;AACzC;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,kCAAkC;IAClC,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,4CAA4C;IAC5C,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA,0CAA0C;AAC1C;IACI,aAAa;IACb,iCAAiC;IACjC,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,qFAAqF;IACrF,iBAAiB;IACjB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,eAAe;IACf,cAAc;IACd,sBAAsB;IACtB,2BAA2B;IAC3B,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA,2BAA2B;AAC3B;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kCAAkC;IAClC,gBAAgB;IAChB,qBAAqB;IACrB,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,mBAAmB;IACnB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA,qCAAqC;AACrC;IACI,oBAAoB;AACxB;;AAEA;IACI,6DAA6D;IAC7D,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;AACnB;;AAEA,iCAAiC;AACjC;IACI,0BAA0B;IAC1B,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,8CAA8C;IAC9C,SAAS;IACT,oBAAoB;IACpB,iDAAiD;AACrD;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,oCAAoC;IACpC,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,oCAAoC;IACpC,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,SAAO;IACP,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,WAAW;IACX,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,2BAA2B;IAC3B,cAAc;IACd,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,cAAc;AAClB;;AAEA,sCAAsC;AACtC;IACI,aAAa;AACjB;;AAEA,qCAAqC;AACrC;IACI;QACI,SAAS;IACb;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,qCAAqC;IACzC;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,eAAe;QACf,SAAS;IACb;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,oBAAoB;QACpB,SAAS;IACb;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,qCAAqC;QACrC,SAAS;IACb;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,8BAA8B;QAC9B,SAAS;IACb;;IAEA,wBAAwB;IACxB;QACI,cAAc;QACd,eAAe;QACf,MAAM;QACN,QAAQ;QACR,aAAa;QACb,UAAU;QACV,gBAAgB;QAChB,gBAAgB;QAChB,2CAA2C;QAC3C,YAAY;QACZ,2BAA2B;QAC3B,8BAA8B;QAC9B,aAAa;IACjB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,gBAAgB;QAChB,YAAY;QACZ,eAAe;QACf,qBAAqB;QACrB,mBAAmB;QACnB,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;QAChB,UAAU;QACV,aAAa;QACb,sBAAsB;QACtB,QAAQ;IACZ;;IAEA;QACI,cAAc;QACd,iBAAiB;QACjB,eAAe;QACf,gBAAgB;QAChB,qBAAqB;QACrB,qBAAqB;QACrB,gCAAgC;IACpC;;IAEA;QACI,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,QAAQ;QACR,6BAA6B;QAC7B,WAAW;IACf;AACJ;;AAEA;IACI;QACI,8BAA8B;IAClC;;IAEA;QACI,YAAY;QACZ,SAAS;IACb;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,QAAQ;QACR,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;AACJ","sourcesContent":["/* ============================================================\n   ToursXplorer Supplier — Public Landing Page\n   Self-contained styles (prefix: lp-)\n   Theme: #F5A524 (amber) / #161C27 (dark)\n   ============================================================ */\n\n.lp-page {\n    --lp-amber: #E3BD3E;\n    --lp-amber-dark: #c9a52f;\n    --lp-dark: #161C27;\n    --lp-text: #3f4654;\n    --lp-muted: #6b7280;\n    --lp-cream: #FFF9F0;\n    --lp-cream-2: #FDF3E4;\n    --lp-hero-bg: #FEFEFE;\n    --lp-border: #efe6d6;\n    --lp-white: #ffffff;\n    font-family: 'Manrope-Regular', 'Segoe UI', system-ui, -apple-system, sans-serif;\n    color: var(--lp-text);\n    background: var(--lp-hero-bg);\n    overflow-x: hidden;\n}\n\n.lp-page * {\n    box-sizing: border-box;\n}\n\n/* Match the supplier app — Manrope family (@font-face defined globally in /assest/css/style.css).\n   Each weight is its own font file, so use the named family rather than font-weight. */\n.lp-page h1,\n.lp-page h2,\n.lp-page h3,\n.lp-page h4,\n.lp-page h5,\n.lp-page h6,\n.lp-stat-num,\n.lp-fc-num {\n    font-family: 'Manrope-Bold';\n}\n\n.lp-btn,\n.lp-nav a,\n.lp-eyebrow,\n.lp-badge,\n.lp-hero-checks span,\n.lp-tag-choice,\n.lp-brands-box .lp-brand,\n.lp-testimonial-author span {\n    font-family: 'Manrope-SemiBold';\n}\n\n.lp-container {\n    width: 100%;\n    max-width: 1320px;\n    margin: 0 auto;\n    padding: 0 20px;\n}\n\n.lp-page img:not(.lp-hero-image) {\n    max-width: 100%;\n}\n\n/* Offset anchored sections so the sticky header doesn't cover their headings */\n.lp-page section[id],\n.lp-page #lp-home {\n    scroll-margin-top: 90px;\n}\n\n/* ---------- Buttons ---------- */\n.lp-btn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    font-size: 15px;\n    font-weight: 600;\n    line-height: 1;\n    padding: 13px 24px;\n    border-radius: 10px;\n    border: 1.5px solid transparent;\n    cursor: pointer;\n    text-decoration: none;\n    transition: all .2s ease;\n    white-space: nowrap;\n}\n\n.lp-btn-primary {\n    background: var(--lp-amber);\n    color: #1c1208;\n    box-shadow: none;\n}\n\n.lp-btn-primary:hover {\n    background: var(--lp-amber-dark);\n    color: #1c1208;\n}\n\n.lp-btn-outline {\n    background: transparent;\n    color: var(--lp-dark);\n    border-color: #e2e2e2;\n}\n\n.lp-btn-outline:hover {\n    border-color: var(--lp-amber);\n    color: var(--lp-amber-dark);\n}\n\n.lp-btn-lg {\n    padding: 15px 28px;\n    font-size: 16px;\n}\n\n/* ---------- Header ---------- */\n.lp-header {\n    position: sticky;\n    top: 0;\n    z-index: 50;\n    padding: 10px 0;\n    background: var(--lp-hero-bg);\n    border-bottom: 1px solid #0000001a;\n}\n\n.lp-header-inner {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    height: 68px;\n    gap: 24px;\n}\n\n.lp-logo {\n    display: flex;\n    align-items: center;\n    flex-shrink: 0;\n    text-decoration: none;\n}\n\n.lp-logo-wrap {\n    position: relative;\n    display: inline-block;\n}\n\n.lp-logo-img {\n    width: 152px;\n    height: auto;\n    display: block;\n}\n\n.lp-logo-tag {\n    position: absolute;\n    top: -9px;\n    right: -20px;\n}\n\n.lp-logo-tag img {\n    width: 56px;\n    display: block;\n}\n\n.lp-nav {\n    display: flex;\n    align-items: center;\n    gap: 22px;\n    margin: 0 auto;\n}\n\n.lp-nav a {\n    font-size: 15px;\n    font-weight: 500;\n    color: #4a5160;\n    text-decoration: none;\n    position: relative;\n    white-space: nowrap;\n    transition: color .2s;\n}\n\n.lp-nav a:hover,\n.lp-nav a.active {\n    color: var(--lp-amber-dark);\n}\n\n.lp-nav a.active::after {\n    content: \"\";\n    position: absolute;\n    left: 0;\n    bottom: -30px;\n    width: 100%;\n    height: 2px;\n    background: var(--lp-amber);\n}\n\n.lp-header-actions {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-shrink: 0;\n}\n\n.lp-burger {\n    display: none;\n    background: none;\n    border: none;\n    font-size: 22px;\n    color: var(--lp-dark);\n    cursor: pointer;\n}\n\n/* ---------- Section base ---------- */\n.lp-section {\n    padding: 80px 0;\n}\n\n.lp-eyebrow {\n    display: inline-block;\n    color: var(--lp-amber-dark);\n    font-weight: 600;\n    font-size: 14px;\n    letter-spacing: .3px;\n    margin-bottom: 10px;\n}\n\n.lp-section-title {\n    font-size: 34px;\n    font-weight: 700;\n    color: var(--lp-dark);\n    margin: 0 0 14px;\n    line-height: 1.25;\n}\n\n.lp-section-head {\n    text-align: center;\n    max-width: 640px;\n    margin: 0 auto 50px;\n}\n\n.lp-section-head .lp-section-title {\n    margin-bottom: 0;\n}\n\n.lp-amber-text {\n    color: var(--lp-amber);\n}\n\n/* ---------- Hero ---------- */\n.lp-hero {\n    background: transparent;\n    padding: 34px 0 64px;\n}\n\n.lp-hero-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 12px;\n    align-items: center;\n}\n\n.lp-badge {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    background: #FDEFD3;\n    color: #9a6a05;\n    font-size: 13px;\n    font-weight: 600;\n    padding: 7px 14px;\n    border-radius: 30px;\n    margin-bottom: 22px;\n}\n\n.lp-hero h1 {\n    font-size: 40px;\n    line-height: 1.18;\n    font-weight: 700;\n    color: var(--lp-dark);\n    margin: 0 0 18px;\n}\n\n.lp-hero h1 .lp-h1-line {\n    display: block;\n    white-space: nowrap;\n}\n\n.lp-hero-sub {\n    font-size: 16px;\n    color: var(--lp-muted);\n    max-width: 460px;\n    margin: 0 0 26px;\n    line-height: 1.6;\n}\n\n.lp-hero-features {\n    display: flex;\n    flex-direction: column;\n    gap: 18px;\n    margin-bottom: 30px;\n}\n\n.lp-feature {\n    display: flex;\n    gap: 14px;\n    align-items: flex-start;\n}\n\n.lp-feature-ico {\n    width: 44px;\n    height: 44px;\n    flex-shrink: 0;\n    border-radius: 12px;\n    background: #FDEFD3;\n    color: var(--lp-amber-dark);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 18px;\n}\n\n.lp-feature h4 {\n    margin: 0 0 3px;\n    font-size: 16px;\n    font-weight: 600;\n    color: var(--lp-dark);\n}\n\n.lp-feature p {\n    margin: 0;\n    width: 80%;\n    font-size: 14px;\n    color: var(--lp-muted);\n    line-height: 1.5;\n}\n\n.lp-hero-btns {\n    display: flex;\n    gap: 14px;\n    flex-wrap: wrap;\n    margin-bottom: 22px;\n}\n\n.lp-hero-checks {\n    display: flex;\n    gap: 22px;\n    flex-wrap: wrap;\n}\n\n.lp-hero-checks span {\n    display: inline-flex;\n    align-items: center;\n    gap: 7px;\n    font-size: 13.5px;\n    color: #56607a;\n}\n\n.lp-hero-checks i {\n    color: var(--lp-amber);\n}\n\n/* Hero visual */\n.lp-hero-visual {\n    position: relative;\n}\n\n.lp-hero-image {\n    width: 112%;\n    max-width: 112%;\n    height: auto;\n    display: block;\n    margin-left: 0;\n}\n\n.lp-float-card {\n    position: absolute;\n    background: #fff;\n    border-radius: 16px;\n    box-shadow: 0 18px 45px rgba(22, 28, 39, .16);\n    padding: 16px 18px;\n}\n\n.lp-float-suppliers {\n    bottom: 18px;\n    right: 0;\n    min-width: 200px;\n    z-index: 5;\n}\n\n.lp-avatars {\n    display: flex;\n    align-items: center;\n    margin-bottom: 8px;\n}\n\n.lp-avatars img {\n    width: 34px;\n    height: 34px;\n    border-radius: 50%;\n    object-fit: cover;\n    border: 2px solid #fff;\n    margin-left: -10px;\n}\n\n.lp-avatars img:first-child {\n    margin-left: 0;\n}\n\n.lp-avatars .lp-av-more {\n    width: 34px;\n    height: 34px;\n    border-radius: 50%;\n    background: var(--lp-amber);\n    color: #1c1208;\n    font-size: 11px;\n    font-weight: 700;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: 2px solid #fff;\n    margin-left: -10px;\n}\n\n.lp-float-suppliers h6 {\n    margin: 0;\n    font-size: 14px;\n    font-weight: 700;\n    color: var(--lp-dark);\n}\n\n.lp-stars {\n    color: var(--lp-amber);\n    font-size: 12px;\n    margin-top: 4px;\n}\n\n/* ---------- Brands strip (white pill, real brand logos) ---------- */\n.lp-brands {\n    padding: 24px 0 14px;\n}\n\n.lp-brands-label {\n    text-align: center;\n    font-size: 13px;\n    color: var(--lp-muted);\n    margin-bottom: 16px;\n}\n\n.lp-brands-box {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-wrap: wrap;\n    gap: 20px 38px;\n    width: fit-content;\n    max-width: calc(100% - 40px);\n    margin: 0 auto;\n    background: #fff;\n    border: 1px solid #eef0f2;\n    border-radius: 16px;\n    padding: 22px 44px;\n    box-shadow: 0 12px 30px rgba(22, 28, 39, .06);\n}\n\n.lp-logo-item {\n    display: inline-flex;\n    align-items: center;\n    line-height: 1;\n    height: 34px;\n}\n\n/* Bókun — real dark logo */\n.lp-logo-bokun img {\n    height: 30px;\n    width: auto;\n    display: block;\n}\n\n/* FareHarbor — real vector */\n.lp-logo-fh svg {\n    height: 26px;\n    width: auto;\n    fill: #0a6ece;\n}\n\n/* Pluralo — icon + dark wordmark (project asset is white for dark bg) */\n.lp-logo-pluralo {\n    font-family: 'Manrope-ExtraBold';\n    font-size: 22px;\n    color: #1b1b29;\n    gap: 8px;\n}\n\n.lp-logo-pluralo svg {\n    width: 24px;\n    height: 24px;\n}\n\n/* rezdy — real vector */\n.lp-logo-rezdy svg {\n    height: 26px;\n    width: auto;\n}\n\n/* octo — real vector */\n.lp-logo-octo svg {\n    height: 26px;\n    width: auto;\n}\n\n/* turitop — real logo */\n.lp-logo-turitop img {\n    height: 30px;\n    width: auto;\n    display: block;\n}\n\n.lp-brands-more {\n    font-size: 14px;\n    color: var(--lp-muted);\n}\n\n/* ---------- Visibility section ---------- */\n.lp-visibility {\n    background: linear-gradient(180deg, #FFFCF5 0%, #FFF5E6 100%);\n    padding-top: 18px;\n    padding-bottom: 64px;\n}\n\n.lp-vis-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr;\n    gap: 28px;\n    align-items: center;\n}\n\n/* scroll-reveal so the section draws focus as the visitor reaches it */\n.lp-visibility .lp-vis-grid > * {\n    opacity: 0;\n    transform: translateY(42px) scale(.97);\n    transition: opacity .7s ease, transform .7s cubic-bezier(.22, 1, .36, 1);\n}\n\n.lp-visibility.lp-revealed .lp-vis-grid > * {\n    opacity: 1;\n    transform: none;\n}\n\n.lp-visibility.lp-revealed .lp-vis-grid > *:nth-child(2) {\n    transition-delay: .16s;\n}\n\n.lp-visibility.lp-revealed .lp-vis-grid > *:nth-child(3) {\n    transition-delay: .32s;\n}\n\n/* always-on attention cue on the badge */\n@keyframes lp-badge-pulse {\n    0% {\n        box-shadow: 0 0 0 0 rgba(227, 189, 62, .55);\n    }\n    70% {\n        box-shadow: 0 0 0 12px rgba(227, 189, 62, 0);\n    }\n    100% {\n        box-shadow: 0 0 0 0 rgba(227, 189, 62, 0);\n    }\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .lp-visibility .lp-vis-grid > * {\n        opacity: 1;\n        transform: none;\n        transition: none;\n    }\n\n    .lp-vis-mid .lp-eyebrow {\n        animation: none;\n    }\n}\n\n.lp-vis-mock {\n    background: #FDF3E2;\n    border-radius: 18px;\n    padding: 22px;\n    box-shadow: inset 0 0 0 1px #f4e6cb;\n}\n\n.lp-vis-search {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    background: #fff;\n    border-radius: 10px;\n    padding: 11px 14px;\n    font-size: 13px;\n    color: #9aa1ad;\n    box-shadow: 0 4px 14px rgba(0, 0, 0, .05);\n    margin-bottom: 16px;\n}\n\n.lp-vis-search i {\n    margin-left: auto;\n    color: var(--lp-amber);\n}\n\n.lp-vis-prod {\n    display: flex;\n    gap: 12px;\n    align-items: center;\n    background: #fff;\n    border-radius: 12px;\n    padding: 12px;\n    box-shadow: 0 8px 22px rgba(0, 0, 0, .07);\n    margin-bottom: 14px;\n}\n\n.lp-vis-prod img {\n    width: 64px;\n    height: 56px;\n    object-fit: cover;\n    border-radius: 8px;\n}\n\n.lp-vis-prod h6 {\n    margin: 0 0 4px;\n    font-size: 14px;\n    font-weight: 600;\n    color: var(--lp-dark);\n}\n\n.lp-vis-prod .lp-vis-meta {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 12px;\n    color: var(--lp-muted);\n}\n\n.lp-vis-prod .lp-vis-price {\n    font-weight: 700;\n    color: var(--lp-dark);\n}\n\n.lp-tag-choice {\n    background: #FDEFD3;\n    color: #9a6a05;\n    font-size: 10px;\n    font-weight: 700;\n    padding: 3px 8px;\n    border-radius: 20px;\n}\n\n.lp-vis-ghost {\n    height: 12px;\n    border-radius: 6px;\n    background: #f1e4ca;\n    margin-bottom: 10px;\n}\n\n.lp-vis-ghost.s {\n    width: 60%;\n}\n\n.lp-vis-mid .lp-eyebrow {\n    background: var(--lp-amber);\n    color: #5b4406;\n    padding: 7px 14px;\n    border-radius: 20px;\n    animation: lp-badge-pulse 2.2s ease-out infinite;\n}\n\n.lp-vis-mid h3 {\n    font-size: 30px;\n    font-weight: 700;\n    color: var(--lp-dark);\n    margin: 16px 0 14px;\n    line-height: 1.28;\n}\n\n.lp-vis-mid p {\n    font-size: 14.5px;\n    color: var(--lp-muted);\n    line-height: 1.6;\n    margin: 0;\n}\n\n.lp-vis-list {\n    display: flex;\n    flex-direction: column;\n    gap: 22px;\n}\n\n.lp-vis-item {\n    display: flex;\n    gap: 13px;\n}\n\n.lp-vis-item > i {\n    width: 38px;\n    height: 38px;\n    flex-shrink: 0;\n    border-radius: 10px;\n    background: #FDEFD3;\n    color: var(--lp-amber-dark);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 15px;\n}\n\n.lp-vis-item h5 {\n    margin: 0 0 3px;\n    font-size: 15px;\n    font-weight: 600;\n    color: var(--lp-dark);\n}\n\n.lp-vis-item p {\n    margin: 0;\n    font-size: 13px;\n    color: var(--lp-muted);\n    line-height: 1.5;\n}\n\n/* ---------- Steps ---------- */\n.lp-steps {\n    display: flex;\n    align-items: flex-start;\n    justify-content: center;\n    gap: 0;\n    flex-wrap: wrap;\n}\n\n.lp-step {\n    flex: 1;\n    min-width: 200px;\n    text-align: center;\n    padding: 0 18px;\n}\n\n.lp-step-ico {\n    width: 70px;\n    height: 70px;\n    margin: 0 auto 18px;\n    border-radius: 50%;\n    background: #FDEFD3;\n    color: var(--lp-amber-dark);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 24px;\n}\n\n.lp-step h4 {\n    margin: 0 0 8px;\n    font-size: 17px;\n    font-weight: 600;\n    color: var(--lp-dark);\n}\n\n.lp-step p {\n    margin: 0;\n    font-size: 14px;\n    color: var(--lp-muted);\n    line-height: 1.55;\n}\n\n.lp-step-arrow {\n    align-self: center;\n    color: var(--lp-amber);\n    font-size: 22px;\n    padding-top: 20px;\n    letter-spacing: 2px;\n}\n\n/* ---------- Benefits cards ---------- */\n.lp-benefits {\n    background: #FFFBF3;\n}\n\n.lp-bene-grid {\n    display: grid;\n    grid-template-columns: repeat(6, 1fr);\n    gap: 18px;\n}\n\n.lp-bene-card {\n    background: #fff;\n    border: 1px solid var(--lp-border);\n    border-radius: 16px;\n    padding: 26px 18px;\n    text-align: center;\n    transition: all .25s ease;\n}\n\n.lp-bene-card:hover {\n    transform: translateY(-6px);\n    box-shadow: 0 18px 36px rgba(22, 28, 39, .1);\n    border-color: var(--lp-amber);\n}\n\n.lp-bene-ico {\n    width: 56px;\n    height: 56px;\n    margin: 0 auto 16px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 21px;\n}\n\n.lp-bene-card h4 {\n    margin: 0 0 8px;\n    font-size: 15px;\n    font-weight: 600;\n    color: var(--lp-dark);\n}\n\n.lp-bene-card p {\n    margin: 0;\n    font-size: 12.5px;\n    color: var(--lp-muted);\n    line-height: 1.55;\n}\n\n/* ---------- Trusted / stats ---------- */\n.lp-trusted-grid {\n    display: grid;\n    grid-template-columns: 1.1fr .9fr;\n    gap: 50px;\n    align-items: center;\n}\n\n.lp-trusted-left {\n    text-align: center;\n}\n\n.lp-trusted h2 {\n    font-size: 30px;\n    font-weight: 700;\n    color: var(--lp-dark);\n    margin: 6px 0 30px;\n    line-height: 1.3;\n}\n\n.lp-stats {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 18px;\n}\n\n.lp-stat {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    gap: 4px;\n}\n\n.lp-stat i {\n    font-size: 28px;\n    color: var(--lp-amber);\n    margin-bottom: 8px;\n}\n\n.lp-stat .lp-stat-num {\n    font-size: 24px;\n    font-weight: 700;\n    color: var(--lp-dark);\n    line-height: 1;\n}\n\n.lp-stat .lp-stat-label {\n    font-size: 12.5px;\n    color: var(--lp-muted);\n    margin-top: 5px;\n}\n\n.lp-testimonial {\n    background: #FDF3E2;\n    border: 1px solid #f3e6cd;\n    border-radius: 18px;\n    padding: 32px;\n    position: relative;\n    /* stable height so swapping testimonials of different lengths doesn't shift layout */\n    min-height: 290px;\n    display: flex;\n    flex-direction: column;\n}\n\n.lp-testimonial p {\n    flex: 1;\n}\n\n.lp-testimonial .lp-quote-mark {\n    font-size: 50px;\n    line-height: 1;\n    color: var(--lp-amber);\n    font-family: Georgia, serif;\n    opacity: .5;\n}\n\n.lp-testimonial p {\n    font-size: 15.5px;\n    color: var(--lp-text);\n    line-height: 1.6;\n    margin: 4px 0 22px;\n}\n\n.lp-testimonial-author {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.lp-testimonial-author img {\n    width: 46px;\n    height: 46px;\n    border-radius: 50%;\n    object-fit: cover;\n}\n\n.lp-testimonial-author h6 {\n    margin: 0;\n    font-size: 15px;\n    font-weight: 700;\n    color: var(--lp-dark);\n}\n\n.lp-testimonial-author span {\n    font-size: 12.5px;\n    color: var(--lp-amber-dark);\n}\n\n/* testimonial slider nav */\n.lp-testimonial-nav {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 18px;\n    margin-top: 20px;\n}\n\n.lp-tnav-btn {\n    width: 38px;\n    height: 38px;\n    border-radius: 50%;\n    border: 1px solid var(--lp-border);\n    background: #fff;\n    color: var(--lp-dark);\n    font-size: 13px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all .2s;\n}\n\n.lp-tnav-btn:hover {\n    background: var(--lp-amber);\n    border-color: var(--lp-amber);\n    color: #1c1208;\n}\n\n.lp-tnav-dots {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.lp-tnav-dot {\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    border: none;\n    padding: 0;\n    background: #e2d9c4;\n    cursor: pointer;\n    transition: all .2s;\n}\n\n.lp-tnav-dot.active {\n    width: 22px;\n    border-radius: 5px;\n    background: var(--lp-amber);\n}\n\n/* ---------- CTA banner ---------- */\n.lp-cta {\n    padding: 30px 0 90px;\n}\n\n.lp-cta-box {\n    background: linear-gradient(120deg, #FDF3E2 0%, #FCEBCB 100%);\n    border-radius: 22px;\n    padding: 46px 50px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 30px;\n    flex-wrap: wrap;\n    overflow: hidden;\n    position: relative;\n}\n\n.lp-cta-text {\n    display: flex;\n    align-items: center;\n    gap: 24px;\n}\n\n.lp-cta-img {\n    width: 96px;\n    height: auto;\n    flex-shrink: 0;\n}\n\n.lp-cta-text h3 {\n    margin: 0 0 6px;\n    font-size: 26px;\n    font-weight: 700;\n    color: var(--lp-dark);\n}\n\n.lp-cta-text p {\n    margin: 0;\n    font-size: 14.5px;\n    color: var(--lp-muted);\n}\n\n.lp-cta-btns {\n    display: flex;\n    gap: 14px;\n    flex-wrap: wrap;\n}\n\n/* ---------- Footer ---------- */\n.lp-footer {\n    background: var(--lp-dark);\n    color: #aeb4c0;\n    padding: 60px 0 26px;\n}\n\n.lp-footer-grid {\n    display: grid;\n    grid-template-columns: 2fr 1fr 1fr 1.2fr 1.6fr;\n    gap: 32px;\n    padding-bottom: 40px;\n    border-bottom: 1px solid rgba(255, 255, 255, .08);\n}\n\n.lp-footer-brand img {\n    height: 28px;\n    margin-bottom: 16px;\n}\n\n.lp-footer-brand p {\n    font-size: 13.5px;\n    line-height: 1.6;\n    margin: 0 0 18px;\n    max-width: 280px;\n}\n\n.lp-footer-social {\n    display: flex;\n    gap: 12px;\n}\n\n.lp-footer-social a {\n    width: 36px;\n    height: 36px;\n    border-radius: 50%;\n    background: rgba(255, 255, 255, .08);\n    color: #cfd4dd;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 15px;\n    transition: all .2s;\n}\n\n.lp-footer-social a:hover {\n    background: var(--lp-amber);\n    color: #1c1208;\n}\n\n.lp-footer-col h5 {\n    color: #fff;\n    font-size: 15px;\n    font-weight: 600;\n    margin: 0 0 18px;\n}\n\n.lp-footer-col ul {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 11px;\n}\n\n.lp-footer-col ul a {\n    color: #aeb4c0;\n    font-size: 13.5px;\n    text-decoration: none;\n    transition: color .2s;\n}\n\n.lp-footer-col ul a:hover {\n    color: var(--lp-amber);\n}\n\n.lp-footer-news p {\n    font-size: 13.5px;\n    line-height: 1.6;\n    margin: 0 0 16px;\n}\n\n.lp-news-form {\n    display: flex;\n    background: rgba(255, 255, 255, .08);\n    border-radius: 10px;\n    padding: 5px;\n}\n\n.lp-news-form input {\n    flex: 1;\n    background: transparent;\n    border: none;\n    outline: none;\n    color: #fff;\n    font-size: 13.5px;\n    padding: 9px 12px;\n}\n\n.lp-news-form input::placeholder {\n    color: #8b91a0;\n}\n\n.lp-news-form button {\n    background: var(--lp-amber);\n    color: #1c1208;\n    border: none;\n    width: 40px;\n    border-radius: 8px;\n    cursor: pointer;\n    font-size: 15px;\n    flex-shrink: 0;\n}\n\n.lp-footer-bottom {\n    text-align: center;\n    padding-top: 24px;\n    font-size: 13px;\n    color: #8b91a0;\n}\n\n/* ---------- Mobile menu ---------- */\n.lp-mobile-nav {\n    display: none;\n}\n\n/* ---------- Responsive ---------- */\n@media (max-width: 1024px) {\n    .lp-nav {\n        gap: 18px;\n    }\n\n    .lp-nav a {\n        font-size: 13.5px;\n    }\n\n    .lp-bene-grid {\n        grid-template-columns: repeat(3, 1fr);\n    }\n\n    .lp-vis-grid {\n        grid-template-columns: 1fr;\n    }\n\n    .lp-trusted-grid {\n        grid-template-columns: 1fr;\n    }\n}\n\n@media (max-width: 860px) {\n    .lp-hero-grid {\n        grid-template-columns: 1fr;\n    }\n\n    .lp-hero h1 {\n        font-size: 34px;\n    }\n\n    .lp-hero h1 .lp-h1-line {\n        white-space: normal;\n    }\n\n    .lp-hero-image {\n        width: 100%;\n        max-width: 100%;\n        margin: 0;\n    }\n\n    .lp-hero-visual {\n        margin-top: 30px;\n    }\n\n    .lp-section {\n        padding: 56px 0;\n    }\n\n    .lp-section-title,\n    .lp-trusted h2 {\n        font-size: 26px;\n    }\n\n    .lp-steps {\n        flex-direction: column;\n        align-items: stretch;\n        gap: 30px;\n    }\n\n    .lp-step-arrow {\n        display: none;\n    }\n\n    .lp-stats {\n        grid-template-columns: repeat(2, 1fr);\n        gap: 28px;\n    }\n\n    .lp-cta-box {\n        flex-direction: column;\n        align-items: flex-start;\n        text-align: left;\n        padding: 34px 26px;\n    }\n\n    .lp-footer-grid {\n        grid-template-columns: 1fr 1fr;\n        gap: 28px;\n    }\n\n    /* Mobile slide-in nav */\n    .lp-mobile-nav {\n        display: block;\n        position: fixed;\n        top: 0;\n        right: 0;\n        height: 100vh;\n        width: 78%;\n        max-width: 320px;\n        background: #fff;\n        box-shadow: -10px 0 40px rgba(0, 0, 0, .15);\n        z-index: 100;\n        transform: translateX(100%);\n        transition: transform .3s ease;\n        padding: 24px;\n    }\n\n    .lp-mobile-nav.open {\n        transform: translateX(0);\n    }\n\n    .lp-mobile-nav .lp-mobile-close {\n        background: none;\n        border: none;\n        font-size: 24px;\n        color: var(--lp-dark);\n        margin-bottom: 20px;\n        cursor: pointer;\n    }\n\n    .lp-mobile-nav ul {\n        list-style: none;\n        margin: 0 0 24px;\n        padding: 0;\n        display: flex;\n        flex-direction: column;\n        gap: 4px;\n    }\n\n    .lp-mobile-nav ul a {\n        display: block;\n        padding: 12px 8px;\n        font-size: 15px;\n        font-weight: 500;\n        color: var(--lp-dark);\n        text-decoration: none;\n        border-bottom: 1px solid #f3f3f3;\n    }\n\n    .lp-mobile-nav .lp-btn {\n        width: 100%;\n        margin-bottom: 10px;\n    }\n\n    .lp-mobile-overlay {\n        position: fixed;\n        inset: 0;\n        background: rgba(0, 0, 0, .4);\n        z-index: 99;\n    }\n}\n\n@media (max-width: 560px) {\n    .lp-bene-grid {\n        grid-template-columns: 1fr 1fr;\n    }\n\n    .lp-header-inner {\n        height: 70px;\n        gap: 10px;\n    }\n\n    .lp-logo-img {\n        width: 132px;\n    }\n\n    .lp-logo-tag img {\n        width: 50px;\n    }\n\n    .lp-header-actions {\n        gap: 8px;\n    }\n\n    .lp-header-actions .lp-btn {\n        padding: 9px 13px;\n        font-size: 13px;\n    }\n\n    .lp-hero h1 {\n        font-size: 30px;\n    }\n\n    .lp-float-suppliers {\n        right: 0;\n        bottom: 12px;\n        min-width: 170px;\n    }\n\n    .lp-footer-grid {\n        grid-template-columns: 1fr;\n    }\n\n    .lp-cta-text {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
